import { useTheme, Breakpoint } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useIsUp = (breakpoint: Breakpoint = 'sm') => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up(breakpoint));
};
